import { createSlice } from '@reduxjs/toolkit';

import { ConnectLaunchState } from './connect-launch.interface';
import { submitConnectSection } from './connect-launch.thunk';
import { defaultApiState } from '../../common/constants/api-constants';
import { ActionStatus } from '../../common/constants/action-status';

/*----- CREATE INITIAL STATE ------*/

export const connectLaunchStateInitialState: ConnectLaunchState = defaultApiState;

/*----- CREATE STORE SLICE ------*/

export const connectLaunchSlice = createSlice({
  name: 'connectLaunch',
  initialState: connectLaunchStateInitialState,
  reducers: {
    updateConnectLaunchStatus(state, action) {
      state.status = ActionStatus[action.payload];
    }
  },
  extraReducers(builder) {
    builder
      .addCase(submitConnectSection.pending, (state) => {
        state.status = ActionStatus.loading;
      })
      .addCase(submitConnectSection.fulfilled, (state, action) => {
        state.status = ActionStatus.succeeded;
        state.data = action.payload;
        state.error = undefined;
      })
      .addCase(submitConnectSection.rejected, (state, action: any) => {
        state.status = ActionStatus.failed;
        state.error = action.payload.message;
        state.data = undefined;
      });
  }
});

/*----- CREATE SLICE ACTIONS ------*/

export const { updateConnectLaunchStatus } = connectLaunchSlice.actions;

/*----- CREATE REDUCER ------*/

export const connectLaunchReducer = connectLaunchSlice.reducer;
